import axios from "../../../config/axiosConfig";

const base = "/api/ordenes-compra";

export const getCatalogosOC = () => axios.get(`${base}/catalogos`);
export const buscarProveedoresOC = (q) => axios.get(`${base}/proveedores`, { params: { q } });
export const buscarClientesOC = (q) => axios.get(`${base}/clientes`, { params: { q } });
export const catalogoEquiposOC = (servicio) => axios.get(`${base}/catalogo/equipos`, { params: { servicio } });
export const catalogoTiposOC = (equipo) => axios.get(`${base}/catalogo/tipos`, { params: { equipo } });
export const catalogoModelosOC = (tipo) => axios.get(`${base}/catalogo/modelos`, { params: { tipo } });
export const buscarEgresosOC = (params) => axios.get(`${base}/egresos`, { params });

export const opcionesReporte = () => axios.get(`${base}/reporte/opciones`);
export const listarReporte = (params) => axios.get(`${base}/reporte`, { params });
export const listarOrdenes = (params) => axios.get(base, { params });
export const crearOrden = (body) => axios.post(base, body);
export const getOrden = (id) => axios.get(`${base}/${id}`);
export const editarOrden = (id, body) => axios.put(`${base}/${id}`, body);
export const finalizarOrden = (id) => axios.post(`${base}/${id}/finalizar`);

export const agregarLinea = (id, body) => axios.post(`${base}/${id}/lineas`, body);
export const editarLinea = (id, linea, body) => axios.put(`${base}/${id}/lineas/${linea}`, body);
export const eliminarLinea = (id, linea) => axios.delete(`${base}/${id}/lineas/${linea}`);

export const formatoEquiposLinea = (id, linea) => axios.get(`${base}/${id}/lineas/${linea}/equipos/formato`);
export const listarEquiposLinea = (id, linea, params) => axios.get(`${base}/${id}/lineas/${linea}/equipos`, { params });
export const previsualizarEquipos = (id, linea, formData) => axios.post(`${base}/${id}/lineas/${linea}/equipos/previsualizar`, formData);
export const registrarEquipos = (id, linea, body) => axios.post(`${base}/${id}/lineas/${linea}/equipos`, body);

export const agregarAduana = (id, body) => axios.post(`${base}/${id}/aduanas`, body);
export const editarAduana = (id, aduana, body) => axios.put(`${base}/${id}/aduanas/${aduana}`, body);

export const enlazarPago = (id, body) => axios.post(`${base}/${id}/pagos`, body);

export const subirArchivosOC = (id, archivos) => {
  const fd = new FormData();
  archivos.forEach((f) => fd.append("archivos", f));
  return axios.post(`${base}/${id}/archivos`, fd);
};
export const eliminarArchivoOC = (id, archivo) => axios.delete(`${base}/${id}/archivos/${encodeURIComponent(archivo)}`);

export const mensajeError = (e, defecto) => e?.response?.data?.error || e?.response?.data?.message || e?.message || defecto;

export const fmt = (n) => (Number(n) || 0).toLocaleString("es-BO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const monedaTexto = (m) => (String(m) === "1" ? "Dólares" : "Bolivianos");
export const simbolo = (m) => (String(m) === "1" ? "$us" : "Bs");
